<template>
  <div class="container">
    <headerSearch ref="headerSearch"></headerSearch>
    <mainTab :nindex="tabIndex"></mainTab>
    <div class="find_product_detail">
      <div class="wrap1 w1440">
        <div class="fs14 flex-box">
          <div class="col90">当前位置：</div>
          <router-link class="col04" :to="tabIndex == 1 ? '/FindProduct' : '/Activities'">
            {{ tabIndex == 1 ? "产品商城" : "活动中心" }}
            <span class="plr5">/</span>
          </router-link>
          <!-- <div class="col04">{{ activity ? activity.title : "找品详情" }}</div> -->
          <div class="col04">
            {{
              activityType == "groupon"
                ? "万件拼团"
                : activityType == "new_sample"
                ? "新品体验"
                : activityType == "seckill"
                ? "限时购"
                : activityType == "expiry_food"
                ? "临期产品"
                : "找品详情"
            }}
          </div>
        </div>
        <!-- 商品 -->
        <div class="product_wrap flex-box flex-col-start">
          <!-- 大图 -->
          <div class="img_box" ref="big-img-box" @mouseleave="moveend">
            <!-- <img :src="product.images_text[currentImg]" class="img1" /> -->

            <vue-photo-zoom-pro :width="300" :scale="1.3" out-zoomer style="height: 100%" :url="product.images_text[currentImg]">
              <!-- 新品体验 -->
              <div v-if="product.activity_type == 'new_sample'">
                <!-- <div class="img_tip1">
                <div class="flex-box flex-col-baseline">
                  <div class="text1 fs20">限前</div>
                  <div class="text2">100</div>
                  <div class="text1 fs20">位</div>
                </div>
                <img src="@/assets/static/icon/z_icon_heart1.png" class="icon_heart" />
              </div> -->
                <div class="img_tip2 flex-box flex-col-end">
                  <div class="mr20">
                    <div class="text1 fs30">新品</div>
                    <div class="text1 fs30">试用</div>
                  </div>
                  <countDown2 ref="countDown" :time="activity.seconds * 1000" @change="onChange">
                    <div class="flex-box flex-col-end">
                      <div class="text2 fs20">距结束还有</div>
                      <div class="time">{{ timeData.days }}</div>
                      <div class="text2 fs20">天</div>
                      <div class="time">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</div>
                      <div class="text2 fs20">时</div>
                      <div class="time">{{ timeData.minutes }}</div>
                      <div class="text2 fs20">分</div>
                      <div class="time">{{ timeData.seconds }}</div>
                      <div class="text2 fs20">秒</div>
                    </div>
                  </countDown2>
                </div>
              </div>
              <!-- 万件拼团 -->
              <div
                v-else-if="
                  product.activity_type == 'groupon' ||
                  product.activity_type == 'expiry_food' ||
                  product.activity_type == 'seckill'
                "
              >
                <countDown2 ref="countDown" :time="activity.seconds * 1000" @change="onChange">
                  <div class="img_tip3 flex-box flex-center flex-col-baseline">
                    <div class="text1 fs20">距结束还有</div>
                    <div class="time">{{ timeData.days }}</div>
                    <div class="text1 fs20">天</div>
                    <div class="time">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</div>
                    <div class="text1 fs20">时</div>
                    <div class="time">{{ timeData.minutes }}</div>
                    <div class="text1 fs20">分</div>
                    <div class="time">{{ timeData.seconds }}</div>
                    <div class="text1 fs20">秒</div>
                  </div>
                </countDown2>
              </div>
            </vue-photo-zoom-pro>
          </div>
          <!-- 小图 -->
          <div class="img_col">
            <div
              class="mini_img_box"
              :class="{ active: currentImg == index }"
              v-for="(item, index) in product.images_text"
              :key="index"
              @click="changeImg(index)"
            >
              <img :src="item" class="mini_img" />
            </div>
          </div>
          <!-- 商品信息 -->
          <div class="flex-grow-1" style="line-height: 2">
            <h2 class="product_name">
              {{ product.title }}
            </h2>

            <div class="product_label flex-box flex-wrap">
              <div class="item fs12" v-for="(service, index) in product.service" :key="index">{{ service.name }}</div>
            </div>

            <div class="flex-box">
              <img v-if="product.activity_type == 'seckill'" src="@/assets/static/icon/z_icon_miao.png" class="icon_miao" />

              <div class="product_price" v-if="!userInfo">
                <span class="price2 fs18">价格登录可见</span>
              </div>

              <div class="product_price" v-else>
                <span class="price1 fs16">¥</span>
                <span class="price2 fs18" v-if="product.activity_type == 'groupon'">
                  {{ product.sku_prices[0].price }}
                </span>
                <span class="price2 fs18" v-else-if="product.activity_type == 'new_sample'">
                  {{ product.sku_prices[0].price }}
                </span>
                <span class="price2 fs18" v-else-if="product.activity_type == 'expiry_food'">
                  {{ product.sku_prices[0].price }}
                </span>
                <span class="price2 fs18" v-else-if="product.activity_type == 'seckill'">
                  {{ product.sku_prices[0].price }}
                </span>
                <span class="price2 fs18" v-else>{{
                  product.min_max_price[0].min_price + "~" + product.min_max_price[0].max_price
                }}</span>
                <span class="price1 fs16" v-if="!product.activity_type"></span>
              </div>
            </div>

            <div class="product_info fs14 mt5" style="line-height: 2">
              <div class="">
                规格型号：{{ product.sku_prices[0].goods_sku_text ? product.sku_prices[0].goods_sku_text : "无" }}
              </div>
              <div class="">批准文号：{{ product.approval_no ? product.approval_no : "无" }}</div>
              <div class="">有效期：{{ product.expiretime ? product.expiretime : "无" }}</div>
            </div>

            <div class="flex-box mt5" v-if="!product.activity_type && product.ladder_price.length > 0">
              <img src="@/assets/static/icon/notice_black.png" class="icon_notice" />
              <div class="fs14 zcol27" style="line-height: 2">阶梯价格说明</div>
            </div>

            <div class="mt5" v-if="!product.activity_type && product.ladder_price.length > 0">
              <div class="fs14 zcol27 flex-box" style="line-height: 2" v-for="(item, index) in product.ladder_price" :key="index">
                <div style="width: 300px">采购量：{{ item.min_count }} ~ {{ item.max_count }}{{ product.unit }}</div>
                <span class="zprice1">￥ {{ item.salesprice }}元/{{ product.unit }}</span>
              </div>
            </div>

            <!-- 临期产品 -->
            <div class="endline mt5 mb15" v-if="product.activity_type == 'expiry_food'">
              有效期至：{{ product.sku_prices[0].expiretime }}
            </div>

            <div class="flex-box mb20 mt5">
              <div class="fs16 zcol27 mr15">数量</div>
              <!-- 无活动商品 -->
              <div class="count_box flex-box" v-if="!product.activity_type">
                <div class="action action1" @click="numMinus"></div>
                <input class="num fs16" v-model="buyNum" @input="validateInteger" />
                <div class="action action2" @click="numAdd"></div>
              </div>
              <!-- 有活动商品 -->
              <div class="count_box flex-box" v-else>
                <div class="action action1" @click="numMinus1"></div>
                <input class="num fs16" v-model="buyNum" @input="validateInteger1" />
                <div class="action action2" @click="numAdd1"></div>
              </div>
              <!-- 库存 -->
              <div class="inventory fs16 flex-grow-1" v-if="!product.activity_type">库存：{{ product.sku_prices[0].stock }}</div>

              <div class="inventory fs16 flex-grow-1" v-if="product.activity_type == 'seckill'">
                库存：{{ product.sku_prices[0].stock }}
              </div>

              <div class="inventory fs16 flex-grow-1" v-if="product.activity_type !== 'new_sample'">
                起订量：{{ product.activity_type ? product.sku_prices[0].buy_qi : product.buy_qi }}
              </div>

              <div class="inventory fs16 flex-grow-1" v-if="product.activity_type == 'new_sample'">
                可购数量：{{ product.can_buy }}
              </div>

              <div class="inventory fs16 flex-grow-1" v-if="product.activity_type == 'expiry_food'">
                已售：{{ product.sku_prices[0].sales }}
              </div>

              <div class="flex-box btn_coll zpointer fs16" v-if="!product.activity_type" @click="toggleCollect()">
                <img
                  :src="
                    product.favorite_count
                      ? require('@/assets/static/icon/z_icon_collecton.png')
                      : require('@/assets/static/icon/z_icon_collect.png')
                  "
                />
                <div>收藏</div>
              </div>
            </div>

            <div class="flex-box flex-between">
              <!-- 新品体验 -->
              <template v-if="activity && activity.status !== 'ing'">
                <div class="flex-box flex-grow-1">
                  <div class="btn_buy btn_gray" v-if="activity.status == 'nostart'">活动未开始</div>
                  <div class="btn_buy btn_gray" v-else-if="activity.status == 'prehead'">活动预热中</div>
                  <div class="btn_buy btn_gray" v-else-if="activity.status == 'end'">活动已结束</div>
                </div>
              </template>
              <template v-else>
                <div v-if="activityType == 'new_sample'" class="btn_buy" @click="onBuy">立即报名</div>
                <div v-if="product.activity_type == 'new_sample'" class="fs16 zcol96">
                  已有
                  <span class="zbule1 fs16 fwb">{{ product.enroll_count }}</span>
                  家机构报名
                </div>

                <template v-if="product.activity_type != 'new_sample'">
                <div v-if="activityType != 'new_sample' && activityType != 'groupon'" class="btn_cart" @click="onAddCart">
                  加入购物车
                </div>
                <div v-if="!activityType || activityType == 'expiry_food' || activityType == 'seckill'">
                  <div class="btn_buy" @click="onBuy">立即购买</div>
                </div>
                </template>

                <div v-if="activityType == 'groupon'" class="btn_buy" @click="onBuy">立即拼团</div>
              </template>
            </div>
          </div>
        </div>
        <!-- 拼团进度 -->
        <div class="group_wrap" v-if="product.activity_type == 'groupon'">
          <div class="flex-box mb40">
            <div class="fs16 zcol27 flex-grow-1">拼团进度</div>
            <div class="fs16 zcol27 mr15">总件数：{{ product.groupon_max.max_count }}</div>
            <div class="fs16 zcol27" v-if="product.groupon_max.max_count - product.sku_prices[0].sales > 0">
              还差
              <span class="fs18 zprice1">{{ product.groupon_max.max_count - product.sku_prices[0].sales }}</span>
              件成团
            </div>
            <div class="fs16 zcol27" v-else>已成团</div>
          </div>
          <div class="text1 flex-box flex-between">
            <div class="fs16">0%</div>
            <div class="fs16" v-for="(item, index) in product.ladder_pricing_rate" :key="index">{{ item.rate }}%</div>
          </div>
          <div class="progress_bar flex-box">
            <div class="progress_inner" :style="{ width: product.rate + '%' }"></div>
          </div>
          <div class="text2 flex-box flex-between">
            <div class="fs16">{{ product.sku_prices[0].price }}元</div>
            <div class="fs16" v-for="(item, index) in product.ladder_pricing_rate" :key="index">{{ item.salesprice }}元</div>
          </div>
          <div class="flex-box">
            <div class="fs16 zcol27 mr30 fwb">已有{{ product.team_count || 0 }}人拼团</div>
            <div class="flex-grow-1">
              <div class="flex-grow-1 flex-box" style="width: unset" v-if="product.groupons.length > 0">
                <img
                  v-show="index <= 5"
                  v-for="(item, index) in product.groupons"
                  :key="index"
                  :src="item.institution.avatar"
                  class="img_head1"
                />
                <div class="flex-box plr15" v-show="product.groupons.length > 3">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
                <img
                  v-show="product.groupons.length > 3 && index == product.groupons.length - 1"
                  v-for="(item, index) in product.groupons"
                  :key="index"
                  :src="item.institution.avatar"
                  class="img_head1"
                />
              </div>
            </div>

            <swiper
              :autoplay="{ delay: 3000, disableOnInteraction: false }"
              @swiper="onLettersSwiper"
              class="letters_swiper"
              :observer="true"
              :observeParents="true"
              :modules="lettersModules"
              direction="vertical"
              loop
            >
              <swiper-slide v-for="(item, index) in product.groupons" :key="index">
                <div class="flex-box notice">
                  <img src="@/assets/static/icon/z_icon_time1.png" class="icon_time" />
                  <div class="fs16">
                    {{ item.createtime_cha }} {{ item.institution.company_name }}已拼{{ item.goods_num }}{{ product.unit }}
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <!-- tab -->
      <div class="product_tabs flex-box flex-end fs16">
        <div class="item" :class="{ active: tabIdx == 0 }" @click="tabClick(0)">基本参数</div>
        <div class="item" :class="{ active: tabIdx == 1 }" @click="tabClick(1)">详情信息</div>
        <div class="item" :class="{ active: tabIdx == 2 }" @click="tabClick(2)">注意事项</div>
      </div>

      <div class="wrap2 w1440 flex-box flex-col-start">
        <!-- 热销榜 -->
        <div class="hot_list">
          <div class="title flex-box flex-center fs18">
            <img src="@/assets/static/icon/z_icon_hot.png" />
            <div>热销榜</div>
          </div>
          <!-- -->
          <div class="hot_item flex-box cursor" v-for="(goods, index1) in goodsList" :key="index1" @click="onDetail(goods.id)">
            <img :src="goods.image_text" class="img1" />
            <div class="flex-grow-1">
              <div class="flex-box flex-col-baseline">
                <div class="price_num fs16" v-if="goods.min_max_price[0].min_price">
                  ¥ {{ goods.min_max_price[0].min_price + "~" + goods.min_max_price[0].max_price }}
                </div>
                <div class="price_num fs16" v-else>暂无价格</div>
                <div class="price_unit fs14">/{{ goods.unit }}</div>
              </div>
              <div class="name fs16 m-ellipsis">{{ goods.title }}</div>
              <div class="spec fs12 m-ellipsis" v-for="(params, index) in goods.params_text" :key="index" v-show="index < 3">
                {{ params.title }}：{{ params.content }}
              </div>
            </div>
          </div>
          <!--  -->
          <router-link to="/FindProduct">
            <div class="flex-box flex-center link_more fs16">
              <div>查看更多</div>
              <img src="@/assets/static/icon/z_icon_more.png" class="icon_more" />
            </div>
          </router-link>
        </div>
        <!-- tab详情区 -->
        <div class="flex-grow-1 tab_block">
          <!-- 基本参数 -->
          <div class="block block1 fs15" id="block0">
            <h2 class="block_title">基本参数</h2>
            <div class="spec_row flex-box" v-for="(item, index) in product.params_text" :key="index">
              <div class="key">{{ item.title }}</div>
              <div class="flex-grow-1 value">{{ item.content }}</div>
            </div>
          </div>
          <!-- 详情信息 -->
          <div class="block block2" id="block1">
            <h2 class="block_title">详情信息</h2>
            <div v-html="product.content"></div>
            <!-- <img src="@/assets/static/images/z_img_detail.png" class="img_detail" /> -->
          </div>
          <!-- 注意事项 -->
          <div class="block block3" id="block2">
            <h2 class="block_title">注意事项</h2>
            <div v-html="product.attention"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useHead } from "@unhead/vue";
import { ref, onMounted, getCurrentInstance } from "vue";
import { Navigation, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "../../../node_modules/swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import countDown2 from "../../components/countDown2.vue";
import VuePhotoZoomPro from "vue-photo-zoom-pro";
import "vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css";

export default {
  name: "FindProductDetail",

  data() {
    return {
      tabIndex: 1, // 顶部tab栏
      currentImg: 0,
      cartRefreshStatus: false,
      userInfo: null,
      activityId: 0,
      activityType: "",
      id: 0,
      state: 0, //0:普通产品null 1:临期产品 2:今日秒杀 3:新品体验 new_sample 4:万件拼团groupon 5:明日预告
      product: {
        title: "",
        buy_qi: 0,
        activity_type: "",
        images_text: [],
        sku_prices: [
          {
            buy_qi: 0,
            price: "",
            stock: 0,
          },
        ],
        service: [],
        ladder_price: [],
        ladder_pricing_rate: [],
        groupons: [],
        min_max_price: [
          {
            min_price: "",
            max_price: "",
          },
        ],
      },
      activity: null,
      timeData: {},
      price: 0, //当前单价
      popType: "buy",
      buyNum: 1,
      totalPrice: 0,
      tabIdx: 0, // 详情Tab
      first_category_id: 0, // 产品分类id
      goods_category: "",
      // 热销榜
      goodsList: [],
      query: {
        keyword: "",
        first_category_id: 0,
        category_id: 0,
        min_price: "",
        max_price: "",
        min_stock: "",
        max_stock: "",
        sort: "",
        order: "",
      },
      oAppLeft: 0,
      oAppTop: 0,
    };
  },
  created() {
    // 用户
    this.userInfo = this.$cookies.get("userinfo");
    // 产品id
    this.id = parseInt(this.$route.query.id) || 0;
    // 活动id
    if (this.$route.query.activity_id) {
      this.activityId = parseInt(this.$route.query.activity_id);
    }
    //  else if (this.$route.query.activity_id) {
    //   this.activityId = this.$route.query.activity_id;
    // }
    // 活动类型
    if (this.$route.query.activity_type) {
      this.activityType = this.$route.query.activity_type || "";
      this.tabIndex = 2;
    }
    // 产品分类id
    if (this.$route.query.first_category_id) {
      this.first_category_id = this.$route.query.first_category_id;
    } else {
      this.first_category_id = 0;
    }
    // 商品详情
    this.productDetail();
    // 获取分类
    // this.getCategory();
    // 获取热销榜
    this.fetch();
  },
  mounted() {
    this.$nextTick(() => {
      //页面加载完成后再去获取`dom`元素的位置
      this.oAppLeft = this.$refs["big-img-box"].offsetLeft;
      this.oAppTop = this.$refs["big-img-box"].offsetTop;
    });
    window.addEventListener("scroll", this.hand);
  },
  methods: {
    // 获取分类
    getCategory() {
      let defaultList = [
        {
          id: 0,
          name: "热门产品",
          children: [],
        },
      ];
      this.$api.GetCategoryList().then((res) => {
        if (res.code == 1) {
          this.categoryList = defaultList.concat(res.data);
          for (let i = 0; i < this.categoryList.length; i++) {
            if (this.categoryList[i].id == this.first_category_id) {
              this.goods_category = this.categoryList[i].name;
              break;
            }
          }
        }
      });
    },
    // 商品详情
    productDetail() {
      let that = this;
      let query = {
        id: that.id,
        activity_id: that.activityId,
      };
      that.$api.GetGoodsDetail1(query).then((res) => {
        that.product = res.data.goods;
        that.activity = res.data.activity;
        let productTitle = res.data.goods.title;
        if (that.product.activity_type) {
          that.buyNum = that.product.sku_prices[0].buy_qi > 0 ? that.product.sku_prices[0].buy_qi : 1;
        } else {
          that.buyNum = that.product.buy_qi > 0 ? that.product.buy_qi : 1;
        }
        if (that.product.activity_type) {
          setTimeout(function () {
            that.$refs.countDown.start();
          }, 500);
        }
        // 商品默认购买数为1时 计算一次价格
        this.calcuPrice();

        useHead({
          title: productTitle + "-小狮优选",
          meta: [
            { name: "description", content: "This is my page description" },
            { property: "og:title", content: "My Page Title" },
            { property: "og:description", content: "This is my page description" },
            { property: "og:url", content: "https://example.com/my-page" },
            { property: "og:image", content: "https://example.com/my-image.jpg" },
          ],
          link: [{ rel: "canonical", href: "https://example.com/my-page" }],
        });
      });
    },
    // 图片切换
    changeImg(i) {
      this.currentImg = i;
    },

    // 普通商品输入整数验证
    validateInteger(event) {
      const regex = /^[0-9]*$/;
      if (!regex.test(event.target.value)) {
        this.buyNum = event.target.value.replace(/[^0-9]/g, "");
      }
      if (this.buyNum > this.product.min_max_price[0].max_count) {
        this.buyNum = this.product.min_max_price[0].max_count;
      }
      if (this.product.buy_qi > this.buyNum) {
        this.$message({
          customClass: "custom-message",
          message: "不得低于起订量",
          type: "error",
          duration: 3000,
        });
        this.buyNum = this.product.buy_qi;
      }
      this.calcuPrice();
    },
    // 普通商品减1
    numMinus() {
      let num = Number(this.buyNum);
      let newNum = this.add(num, -1);
      if (newNum <= 0) {
        return;
      }
      if (this.product.buy_qi > newNum) {
        this.$message({
          customClass: "custom-message",
          message: "不得低于起订量",
          type: "error",
          duration: 3000,
        });
        this.buyNum = this.product.buy_qi;
      } else {
        this.buyNum = newNum;
      }

      this.calcuPrice();
    },
    // 普通商品加1
    numAdd() {
      let num = Number(this.buyNum);
      let newNum = this.add(num, 1);
      this.buyNum = newNum;
      if (this.buyNum > this.product.min_max_price[0].max_count) {
        this.buyNum = this.product.min_max_price[0].max_count;
      }
      this.calcuPrice();
    },

    // 活动商品输入整数验证
    validateInteger1(event) {
      const regex = /^[0-9]*$/;
      if (!regex.test(event.target.value)) {
        this.buyNum = event.target.value.replace(/[^0-9]/g, "");
      }
      if (this.buyNum < this.product.sku_prices[0].buy_qi) {
        this.buyNum = this.product.sku_prices[0].buy_qi;
      }
      if (this.product.sku_prices[0].buy_qi > this.buyNum) {
        this.$message({
          customClass: "custom-message",
          message: "不得低于起订量",
          type: "error",
          duration: 3000,
        });
        this.buyNum = this.product.sku_prices[0].buy_qi;
      }
      this.calcuPrice();
    },
    // 活动商品减1
    numMinus1() {
      let num = Number(this.buyNum);
      let newNum = this.add(num, -1);
      if (newNum <= 0) {
        return;
      }
      if (newNum < this.product.sku_prices[0].buy_qi) {
        return;
      }
      this.buyNum = newNum;
      this.calcuPrice();
    },
    // 活动商品加1
    numAdd1() {
      let num = Number(this.buyNum);
      let newNum = this.add(num, 1);
      if (this.product.activity_type == "new_sample" && this.product.can_buy < newNum) {
        return;
      }
      this.buyNum = newNum;
      this.calcuPrice();
    },

    // 计算价格
    calcuPrice() {
      let price = 0;
      if (this.product.activity_type) {
        price = this.product.sku_prices[0].price;
      } else {
        let ladderPrice = this.product.ladder_price;
        if (ladderPrice.length > 0) {
          for (let i = 0; i < ladderPrice.length; i++) {
            if (this.buyNum >= ladderPrice[i].min_count && this.buyNum <= ladderPrice[i].max_count) {
              price = ladderPrice[i].salesprice;
              break;
            }
          }
        }
      }
      price = price <= 0 ? "0.0" : price;
      this.totalPrice = (price * this.buyNum).toFixed(1);
      this.price = price;
    },

    //（取消）收藏
    toggleCollect() {
      if (!this.userInfo) {
        return;
      }
      let query = {
        goods_id: this.product.id,
      };
      this.$api.ToggleCollect(query).then((res) => {
        this.product.favorite_count = res.data.favorite_count;
      });
    },

    //加入购物车
    async onAddCart(event) {
      let that = this;
      if (!that.userInfo) {
        return;
      }
      if (that.product.sku_prices[0].id) {
        if (that.product.sku_prices[0].stock <= 0) {
          that.$message({
            customClass: "custom-message",
            message: "库存不足",
            type: "error",
            duration: 3000,
          });
        } else {
          let goods_sku_price_id = that.activityId
            ? that.product.sku_prices[0].goods_sku_price_id
            : that.product.sku_prices[0].id;
          let query = {
            goods_id: that.product.id,
            activity_id: that.activityId,
            goods_num: that.buyNum,
            goods_sku_price_id: goods_sku_price_id,
          };
          that.$api.AddCart(query).then((res) => {
            if (res.code == 1) {
              that.$message({
                customClass: "custom-message",
                message: "添加成功",
                type: "success",
                duration: 3000,
              });
            }
            that.$bus.emit("cartRefresh", {});
          });
          const x = event.clientX;
          const y = event.clientY;
          await that.createBall(x, y);
        }
      } else {
        that.$message({
          customClass: "custom-message",
          message: "请选择规格",
          type: "error",
          duration: 3000,
        });
      }
    },

    //动态创建加入购物车的元素，和动画
    createBall(left, top) {
      let that = this;
      return new Promise((reslove) => {
        const bar = document.createElement("img");
        let position = that.$refs.headerSearch.getElementPosition(); //获取顶部按钮位置
        const afterX = position.x; //计算小球最后的位置x
        const afterY = position.y; //计算小球最后的位置Y
        bar.classList = ["cartBall"];
        bar.src = that.product.images_text[that.currentImg];
        bar.style.position = "fixed";
        bar.style.left = left + "px";
        bar.style.top = top + "px";
        bar.style.with = "50px";
        bar.style.height = "50px";
        bar.style.zIndex = "9999";
        bar.style.border = "1px solid red";
        bar.style.transition = "left .6s linear, top .6s cubic-bezier(0.5, -0.5, 1, 1)";
        document.body.appendChild(bar);
        setTimeout(() => {
          const x = afterX;
          const y = afterY;
          bar.style.top = y + "px";
          bar.style.left = x + "px";
        }, 0);
        setTimeout(() => {
          bar.style.display = "none";
          bar.remove();
          reslove();
        }, 600);
      });
    },

    //立即购买
    onBuy() {
      if (this.product.sku_prices[0].goods_id) {
        if (this.product.sku_prices[0].stock <= 0) {
          this.$message({
            customClass: "custom-message",
            message: "库存不足",
            type: "error",
            duration: 3000,
          });
        } else {
          let goods_sku_price_id = this.activityId
            ? this.product.sku_prices[0].goods_sku_price_id
            : this.product.sku_prices[0].id;
          let activityType = this.activityId ? this.activity.type : "";
          let data = JSON.stringify({
            order_type: "goods",
            buy_type: this.activityId ? "activity" : "general",
            goods_list: [
              {
                activity_id: this.activityId,
                activity_type: activityType,
                goods_id: this.product.id,
                goods_num: this.buyNum,
                goods_sku_price_id: goods_sku_price_id,
              },
            ],
          });
          this.$router.push({ path: "/Billing", query: { data: encodeURIComponent(data) } });
        }
      } else {
        that.$message({
          customClass: "custom-message",
          message: "请选择规格",
          type: "error",
          duration: 3000,
        });
      }
    },

    // tab切换
    tabClick(i) {
      window.removeEventListener("scroll", this.hand);
      this.debounce(() => {
        this.tabIdx = i;
      }, 1000);
      var halfWindowHeight = window.innerHeight / 2;
      var target = document.getElementById("block" + i);
      const offsetTop = target.offsetTop - halfWindowHeight + 116;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
      window.addEventListener("scroll", this.hand);
    },

    hand() {
      var halfWindowHeight = window.innerHeight / 2;
      var tabs = document.getElementsByClassName("block");
      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        var coords = tab.getBoundingClientRect();
        if (coords.top <= halfWindowHeight && coords.bottom > halfWindowHeight) {
          if (this.tabIdx != i) {
            this.tabIdx = i;
          }
          break;
        }
      }
    },

    // 获取热销榜商品列表
    fetch() {
      let query = this.query;
      query.list_rows = 3;
      query.page = 1;
      let that = this;
      that.$api
        .GetGoods(query)
        .then((res) => {
          if (res.code == 1) {
            this.goodsList = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 加法
    add(num1, num2) {
      const cardinal = Math.pow(10, 10);
      return Math.round((num1 + num2) * cardinal) / cardinal;
    },

    onDetail(id) {
      // this.$router.push({ path: "/FindProductDetail", query: { id, first_category_id: 0 } });
      const routeData = this.$router.resolve({
        name: "FindProductDetail", // 目标路由的名称
        query: { id, first_category_id: 0 },
      });
      window.open(routeData.href, "_blank");
    },
    refreshSelf() {
      // 产品id
      this.id = this.$route.query.id || 0;
      // 活动id
      this.activityId = 0;
      // 活动类型
      this.activityType = "";
      // 产品分类id
      if (this.$route.query.first_category_id) {
        this.first_category_id = this.$route.query.first_category_id;
      }
      // 商品详情
      this.productDetail();
      // 获取分类
      // this.getCategory();
      // 获取热销榜
      this.fetch();
    },

    //开始
    start() {
      this.$refs.countDown.start();
    },
    // 倒计时
    onChange(e) {
      this.timeData = e;
    },
    debounce(fn, wait) {
      let timeout = null;
      return function () {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        let callNow = !timeout;
        timeout = setTimeout(() => {
          timeout = null;
        }, wait);
        if (callNow) fn.apply(context, args);
      };
    },
  },
  watch: {
    $route: "refreshSelf",
  },
  setup() {
    onMounted(() => {
      useHead({
        title: "商品详情-小狮优选",
        meta: [
          { name: "description", content: "This is my page description" },
          { property: "og:title", content: "My Page Title" },
          { property: "og:description", content: "This is my page description" },
          { property: "og:url", content: "https://example.com/my-page" },
          { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
      });
    });

    const lettersModules = [Navigation, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode];
    let letterSwi = ref("");
    const onLettersSwiper = (e) => {
      letterSwi.value = e;
    };

    return {
      lettersModules,
      onLettersSwiper,
    };
  },
  components: {
    countDown2,
    Swiper,
    SwiperSlide,
    VuePhotoZoomPro,
  },
};
</script>
<style lang="less" scoped>
.find_product_detail {
  // width: 1920px;
  background-color: #fff !important;
}

.wrap1 {
  // padding: 35px 0 40px;
  padding: 0.1rem 0 40px;
}

.product_wrap {
  margin-top: 0.1rem;
  .img_box {
    position: relative;
    margin-right: 35px;
    width: 580px;
    height: 580px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid rgba(98, 134, 171, 0.2);

    .img1 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0 auto;
      display: block;
      max-width: 412px;
      // z-index: 1000;
    }
  }

  // /deep/.img-zoomer {
  //   width: unset !important;
  //   height: unset !important;
  //   transform: unset !important;
  // }

  // /deep/.selector {
  //   position: absolute;
  //   top: 25%;
  //   left: 25%;
  // }
  /deep/.vue-photo-zoom-pro {
    display: block;
  }
  /deep/.vue-photo-zoom-pro .out-zoomer {
    width: 390px !important;
    height: 390px !important;
    z-index: 10 !important;
    background: #fff !important;
    right: -25px !important;
    border-radius: 8px !important;
    border: 1px solid rgba(98, 134, 171, 0.2) !important;
  }

  /deep/.vue-photo-zoom-pro .out-zoomer .img-zoomer {
    height: unset !important;
  }

  /deep/.img-preview {
    height: 578px !important;
    object-fit: contain !important;
    border-radius: 8px !important;
  }

  /deep/ .selector {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }

  .img_col {
    margin-right: 60px;
    padding: 4px 0 0;
    height: 580px;
    overflow-y: scroll;

    .mini_img_box {
      position: relative;
      width: 108px;
      height: 108px;
      border-radius: 8px;
      background: #ffffff rgba(150, 150, 150, 0.06);
      border: 1px solid rgba(98, 134, 171, 0.2);
      cursor: pointer;

      .mini_img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        max-width: 92px;
      }
    }

    .mini_img_box + .mini_img_box {
      margin-top: 10px;
    }

    .mini_img_box.active {
      background-color: #fff;
      border: 2px solid #3d7efe;
    }
  }

  .product_name {
    padding: 6px 0 20px;
    line-height: 32px;
    color: #272727;
    letter-spacing: 1px;

    .name_label {
      vertical-align: 2px;
      margin-left: 10px;
      display: inline-block;
      padding: 0 10px;
      height: 26px;
      border-radius: 65px;
      background: linear-gradient(117deg, #4ac3fc 0%, #3d6cfe 100%);
      color: #fff;
      line-height: 26px;
      font-weight: 700;
    }
  }

  .product_label {
    .item {
      margin: 0 12px 14px 0;
      padding: 0 7px;
      height: 31px;
      border: 2px solid #eb3f25;
      color: #eb3f25;
      line-height: 27px;
      border-radius: 4px;
    }
  }

  .product_price {
    .price1 {
      color: #eb3f25;
      line-height: 24px;
    }

    .price2 {
      font-weight: 700;
      color: #eb3f25;
      line-height: 30px;
    }
  }

  .product_info {
    color: #777777;
  }

  .count_box {
    margin-right: 35px;

    .action {
      position: relative;
      width: 45px;
      height: 40px;
      border: 1px solid #e0e7ee;
      background: #f9f9f9;
      cursor: pointer;
    }

    .action1 {
      border-radius: 10px 0 0 10px;
      border-right: 0;
    }

    .action2 {
      border-radius: 0 10px 10px 0;
      border-left: 0;
    }

    .action::before {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: "";
      width: 16px;
      height: 2px;
      background: #969696;
    }

    .action2::after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: "";
      height: 16px;
      width: 2px;
      background: #969696;
    }

    .num {
      padding: 0 5px;
      width: 70px;
      height: 40px;
      border: 2px solid #3d7efe;
      text-align: center;
      line-height: 36px;
      background: #f9f9f9;
      color: #272727;
    }
  }

  .inventory {
    color: #1275ff;
    line-height: 45px;
  }

  .btn_coll {
    color: #272727;
    text-align: center;

    img {
      margin-right: 14px;
      display: block;
      width: 29px;
      height: 29px;
    }
  }

  .btn_cart {
    width: 307px;
    height: 60px;
    border-radius: 10px;
    border: 1px solid #d2d2d2;
    color: #1275ff;
    font-weight: 700;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
  }

  .btn_buy {
    width: 307px;
    height: 60px;
    border-radius: 10px;
    background: #1275ff;
    color: #ffffff;
    font-weight: 700;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
  }

  .btn_cart + .btn_buy {
    margin-left: 30px;
  }

  .btn_buy.btn_gray {
    background: #d2d2d2 !important;
  }
}

.product_tabs {
  position: sticky;
  top: 40px;
  left: 0;
  right: 0;

  padding: 0 220px 0 0;
  // width: 1920px;
  height: 76px;
  // background: rgba(61, 126, 254, 0.04);
  background: rgb(247, 250, 255);

  .item {
    width: 250px;
    // height: 76px;
    height: 0.3rem;
    color: #040404;
    // line-height: 76px;
    line-height: 0.3rem;
    cursor: pointer;
    text-align: center;
  }

  .item.active {
    position: relative;
    background: rgba(255, 255, 255, 0.8);
  }

  .item.active::before {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    content: "";
    width: 80px;
    height: 4px;
    background: #1275ff;
  }
}

.wrap2 {
  // padding: 0 0 60px;
  padding: 0 0 0.2rem;
}

.hot_list {
  // margin-right: 134px;
  margin-right: 0.3rem;
  // padding: 42px 0 0;
  padding: 0.1rem 0 0;
  width: 480px;

  .link_more {
    .icon_more {
      margin-left: 14px;
      display: block;
      width: 14px;
      height: 14px;
    }

    color: #969696;
    text-decoration: underline;
  }

  .title {
    // margin: 0 0 40px;
    margin: 0 0 0.1rem;
    color: #1275ff;
    font-weight: 700;

    img {
      margin-right: 12px;
      display: block;
      width: 29px;
      height: 34px;
    }
  }

  .hot_item {
    padding: 19px 30px 13px 42px;
    margin: 0 0 24px;
    width: 480px;
    border-radius: 8px;
    background: #f5f8fe;

    .img1 {
      margin-right: 50px;
      display: block;
      width: 154px;
      height: 154px;
      border-radius: 8px;
      background: #ffffff;
    }

    .price_num {
      color: #eb3f25;
      line-height: 31px;
    }

    .price_unit {
      color: #eb3f25;
    }

    .name {
      margin: 5px 0 0;
      color: #272727;
      font-weight: 700;
    }

    .spec {
      margin: 8px 0 0;
      color: #969696;
      line-height: 1.5;
    }
  }
}

.tab_block {
  .block_title {
    margin: 0 0 10px;
    color: #040404;
    font-size: 18px;
    font-weight: 700;
  }
  .block3 {
    .note {
      position: relative;
      margin: 0 0 20px;
      padding-left: 38px;
      color: #c9cdd4;
    }

    .note::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 10px;
      height: 10px;
      background: #1275ff;
      border-radius: 50%;
    }

    padding: 45px 0 0;
  }

  .block2 {
    padding: 45px 0 0;

    .img_detail {
      display: block;
      width: 100%;
    }
  }

  .block1 {
    // padding: 45px 0 0;
    padding: 0.12rem 0 0;

    .spec_row {
      padding: 15px 5px;
      border-bottom: 1px solid rgba(98, 134, 171, 0.6);

      .value {
        color: #272727;
      }

      .key {
        width: 268px;
        color: #969696;
      }
    }
  }
}

.product_wrap {
  .img_tip1 {
    position: absolute;
    bottom: 86px;
    right: 40px;

    .icon_heart {
      position: absolute;
      right: 2px;
      top: 15px;
      display: block;
      width: 23px;
      height: 19px;
    }

    .text1 {
      font-weight: 700;
      color: #ffffff;
      line-height: 34px;
      letter-spacing: 1px;
      text-stroke: 1px #eb3f25;
      text-align: right;
      font-style: normal;
      -webkit-text-stroke: 1px #eb3f25;
    }

    .text2 {
      font-weight: 700;
      font-size: 60px;
      color: #ffffff;
      line-height: 80px;
      letter-spacing: 2px;
      text-stroke: 5px #eb3f25;
      font-style: normal;
      -webkit-text-stroke: 4px #eb3f25;
    }
  }

  .img_tip2 {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 580px;
    height: 118px;
    background-image: url(@/assets/static/icon/z_icon_bg1.png);
    background-size: 579px 118px;
    background-repeat: no-repeat;
    padding: 0 10px 24px 24px;
    border-radius: 0 0 8px 8px;

    .text1 {
      font-weight: 700;
      font-size: 30px;
      color: #ffffff;
      line-height: 36px;
      text-align: left;
      font-style: normal;
    }

    .text2 {
      color: #ffffff;
      line-height: 34px;
      letter-spacing: 1px;
      text-align: left;
      font-style: normal;
    }

    .time {
      margin: 0 8px;
      width: 28px;
      height: 28px;
      background: linear-gradient(177deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      border-radius: 3px;
      font-weight: 700;
      font-size: 22px;
      color: #1275ff;
      line-height: 28px;
      text-align: center;
      font-style: normal;
    }
  }

  .img_tip3 {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 580px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #3d7efe 100%);
    border-radius: 7px;
    padding: 67px 24px 28px;

    .text1 {
      color: #ffffff;
      line-height: 34px;
      letter-spacing: 1px;
      font-style: normal;
    }

    .time {
      margin: 0 8px;
      width: 28px;
      height: 28px;
      background: linear-gradient(177deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      border-radius: 3px;
      font-weight: 700;
      font-size: 22px;
      color: #eb3f25;
      line-height: 28px;
      text-align: center;
      font-style: normal;
    }
  }

  .endline {
    padding: 0 14px;
    display: inline-block;
    height: 36px;
    background: #fff3dc;
    border-radius: 10px;
    font-size: 14px;
    color: #6d5322;
    line-height: 36px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
  }

  .icon_miao {
    margin-right: 8px;
    display: block;
    width: 46px;
    height: 46px;
  }
  .icon_notice {
    margin-right: 5px;
    display: block;
    width: 16px;
    height: 16px;
  }
}

.group_wrap {
  margin: 45px 0 0;
  padding: 40px 0 0;
  border-top: 1px solid rgba(98, 134, 171, 0.6);

  .text1 {
    margin: 0 40px 40px 28px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    font-style: normal;

    div {
      color: #c4c4c4;
      min-width: 5em;
    }

    div:first-of-type {
      text-align: left;
    }

    div:last-of-type {
      text-align: right;
    }
  }

  .progress_bar {
    margin: 0 38px 40px;
    padding: 0 10px;
    height: 30px;
    border-radius: 20px;
    border: 2px solid #e3ecf7;

    .progress_inner {
      position: relative;
      height: 16px;
      background: #feb833;
      border-radius: 32px;
    }

    .progress_inner::after {
      content: "";
      position: absolute;
      right: -22px;
      top: 50%;
      transform: translateY(-50%);
      width: 62px;
      height: 62px;
      background-image: url(@/assets/static/icon/z_icon_progress.png);
      background-size: 62px;
      background-repeat: no-repeat;
    }
  }

  .text2 {
    margin: 0 0 40px;
    padding: 0 40px 0 28px;
    color: #272727;
    line-height: 30px;
    text-align: center;

    .active {
      padding: 0 20px;
      height: 30px;
      background: #feb833;
      border-radius: 22px;
      font-weight: 700;
      font-size: 22px;
      color: #ffffff;
    }

    div {
      min-width: 5em;
    }

    div:first-of-type {
      text-align: left;
    }

    div:last-of-type {
      text-align: right;
    }
  }

  .img_head1 {
    display: block;
    width: 39px;
    height: 39px;
    border-radius: 50%;
  }

  .img_head1 + .img_head1 {
    margin-left: -8px;
  }

  .dot {
    width: 4px;
    height: 4px;
    background: #e0e1e3;
    border-radius: 50%;
  }

  .dot + .dot {
    margin-left: 8px;
  }

  .letters_swiper {
    height: 40px;
  }

  .notice {
    padding: 0 20px;
    height: 40px;
    background: #f6f6f6;
    border-radius: 24px;

    .icon_time {
      margin-right: 10px;
      display: block;
      width: 22px;
      height: 22px;
    }

    div {
      color: #909090;
      line-height: 24px;
      letter-spacing: 1px;
    }
  }
}

@media screen and (max-width: 1440px) {
  .img_col {
    margin-right: 30px !important;
  }
  .btn_cart,
  .btn_buy {
    width: 240px !important;
  }
}
</style>
